import React, { useState, useEffect } from "react";
import { DatePicker, Select, message } from "antd";
import ModalLayout from "../..";
import Button from "../../../button";
import dayjs, { Dayjs } from "dayjs";
import "./style.scss";
import Checkbox from "../../../checkbox";

interface ScheduleDeliveryModalProps {
  open: boolean;
  onClose: () => void;
  onConfirm: (data: { date: string; session: string }) => void;
  loading?: boolean;
  sessionOptions?: string[];
}

const ScheduleDeliveryModal: React.FC<ScheduleDeliveryModalProps> = ({
  open,
  onClose,
  onConfirm,
  loading = false,
  sessionOptions = ["Morning session", "Afternoon session", "Evening session"],
}) => {
  const [date, setDate] = useState<Dayjs | null>(null);
  const [session, setSession] = useState<string>("");
  const [isChecked, setIsChecked] = useState(false);
  useEffect(() => {
    if (open) {
      setDate(null);
      setSession("");
      setIsChecked(false);
    }
  }, [open]);

  const handleConfirm = () => {
    if (!date || !session) {
      message.warning("Please select both date and session.");
      return;
    }
    onConfirm({ date: date.format("YYYY-MM-DD"), session });
  };

  const footer = (
    <div className="confirm-modal-actions">
      <Button className="ant-btn-tertiary" onClick={onClose} disabled={loading}>
        CANCEL
      </Button>
      <Button
        loading={loading}
        className="ant-btn-secondary"
        type="primary"
        onClick={handleConfirm}
      >
        CONFIRM
      </Button>
    </div>
  );

  return (
    <ModalLayout
      open={open}
      onClose={onClose}
      title="Schedule delivery time"
      footer={footer}
      width={470}
      onConfirm={handleConfirm}
    >
      <div className="schedule-modal-wrapper flex flex-col gap-4 mt-3">
        <p>
          {" "}
          Check the bin stock and drive availability, then select the date and
          session.
        </p>
        <div>
          <Checkbox
            checked={isChecked}
            onChange={(e) => setIsChecked(e.target.checked)}
          >
            Check bin stock and driver availability{" "}
          </Checkbox>
        </div>
        <DatePicker
          minDate={dayjs()}
          className="datePicker"
          placeholder="Select date"
          onChange={(value) => setDate(value)}
          value={date}
          disabled={!isChecked || loading}
        />
        <Select
          className="select"
          placeholder="Select session"
          value={session || undefined}
          onChange={setSession}
          disabled={!isChecked || loading}
        >
          {sessionOptions.map((option) => (
            <Select.Option key={option} value={option}>
              {option}
            </Select.Option>
          ))}
        </Select>
      </div>
    </ModalLayout>
  );
};

export default ScheduleDeliveryModal;
